module.exports = __webpack_public_path__ + "img/thumb-collection-loja.6b4147c2.jpg";